import { Injectable } from '@angular/core';
import { OrderingOption } from 'generated/graphql-types';

@Injectable({ providedIn: 'root' })
export class AccountRegisterSessionStorageService {
   private readonly accountOrderingOptionsStorageKey = '__ndt-account-ordering-options';

   clearAll(): void {
      localStorage.clear();
   }

   removeAccountOrderingOptions(): void {
      localStorage.removeItem(this.accountOrderingOptionsStorageKey);
   }

   getAccountOrderingOptions() {
      const localData = localStorage.getItem(this.accountOrderingOptionsStorageKey);
      if (localData) {
         return JSON.parse(localData);
      }
      return null;
   }

   setAccountOrderingOptions(orderingOptions: OrderingOption[] | null): void {
      localStorage.setItem(this.accountOrderingOptionsStorageKey, JSON.stringify(orderingOptions));
   }
}
